<template>
  <div class="mic-control-container">
    <p class="smaller accent">
      {{ t('voice_size') }}
      <span>: {{ userPreferences.voiceSize }}</span>
    </p>

    <Gauge
      :modelValue="userPreferences.voiceSize"
      :disabled="false"
      :min="-0.5"
      :max="0.5"
      :increment="0.25"
      min-label="Min (-0.5)"
      max-label="Max (+0.5)"
      @update:modelValue="changeVoiceSize"
    />
  </div>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import { storeToRefs } from 'pinia';

import Gauge from '@/components/shared/base/Gauge.vue';
import { useSocketStore } from '@/stores/socket';
import { useUserStore } from '@/stores/user';


const userStore = useUserStore();
const { userPreferences } = storeToRefs(userStore);

const { t } = useI18n();
const socketStore = useSocketStore();

const changeVoiceSize = (vad: number) => {
  userPreferences.value.voiceSize = vad;
  socketStore.sendMessageVAD({ vad });
};
</script>

<style scoped lang="scss">
.mic-control-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: fit-content;
  gap: 0.75rem;
}
</style>
